<template>
    <div class="message-composer">
        <div class="composer-wrapper">
            <input :value="messageInput" @input="$emit('update-input', $event.target.value)"
                @keypress.enter="handleSend" type="text" placeholder="Écris un message..." class="message-input" />
            <button @click="handleSend" :disabled="!messageInput.trim()" class="btn-modern btn-primary py-0 px-2">
                <i style="font-size: 20pt;" class="mdi mdi-send-variant"></i>
            </button>
        </div>

        <transition name="fade">
            <div v-if="showWarning" class="warning-message">
                <i class="mdi mdi-alert"></i>
                <span>{{ $t('sentence.warningMsg') }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "MessageComposer",
    props: {
        messageInput: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showWarning: false,
            warningTimeout: null
        };
    },
    methods: {
        containsPersonalInfo(text) {
            // Remove all spaces from text for detection
            const textWithoutSpaces=text.replace(/\s+/g, '');

            // Email pattern
            const emailPattern=/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;

            if (emailPattern.test(textWithoutSpaces)||textWithoutSpaces.toLowerCase().includes('mail')) {
                return true;
            }

            // Phone number patterns (various formats)
            const phonePatterns=[
                /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/, // International
                /\b\d{10}\b/, // 10 consecutive digits
                /\b\d{3}[-.\s]?\d{3}[-.\s]?\d{4}\b/, // US format
                /\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}/, // With parentheses
                /\b0\d{9}\b/, // Starting with 0 (common in many countries)
            ];

            // Check for phone numbers
            for (const pattern of phonePatterns) {
                if (pattern.test(text)) {
                    return true;
                }
            }

            return false;
        },

        displayWarning() {
            this.showWarning=true;

            // Clear existing timeout
            if (this.warningTimeout) {
                clearTimeout(this.warningTimeout);
            }

            // Hide warning after 5 seconds
            this.warningTimeout=setTimeout(() => {
                this.showWarning=false;
            }, 5000);
        },

        handleSend() {
            if (this.messageInput.trim()) {
                if (this.containsPersonalInfo(this.messageInput)) {
                    this.displayWarning();
                    return;
                }
                this.$emit('send');
            }
        }
    },
    beforeUnmount() {
        // Clean up timeout when component is destroyed
        if (this.warningTimeout) {
            clearTimeout(this.warningTimeout);
        }
    }
};
</script>

<style scoped>
.message-composer {
    display: flex;
    flex-direction: column;
    border-top: 1px solid var(--gray-200);
    background: white;
}

.composer-wrapper {
    display: flex;
    align-items: center;
    padding: 16px;
    gap: 8px;
}

.message-input {
    flex: 1;
    padding: 10px 16px;
    border: 1px solid var(--gray-300);
    border-radius: 24px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s;
}

.message-input:focus {
    border-color: var(--color-nz);
}

.btn-modern {
    background: var(--color-nz);
    border: none;
    border-radius: 50%;
    padding: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;
}

.btn-modern:hover:not(:disabled) {
    background: var(--success);
}

.btn-modern:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.warning-message {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #fff3cd;
    border-top: 1px solid #ffc107;
    color: #856404;
    font-size: 14px;
}

.warning-message i {
    font-size: 20px;
    color: #ffc107;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>